var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBriefcase = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66685 5.00032V4.33366C6.66685 2.85866 6.66685 1.66699 9.33351 1.66699H10.6668C13.3335 1.66699 13.3335 2.85866 13.3335 4.33366V5.00032M6.66685 18.3337H13.3335C16.6835 18.3337 17.2835 16.992 17.4585 15.3587L18.0835 8.69199C18.3085 6.65866 17.7252 5.00032 14.1668 5.00032H5.83351C2.27518 5.00032 1.69185 6.65866 1.91685 8.69199L2.54185 15.3587C2.71685 16.992 3.31685 18.3337 6.66685 18.3337Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0414 9.16699C16.1632 10.531 13.9699 11.3969 11.6664 11.6837M2.18311 9.39199C4.05811 10.6753 6.17477 11.4503 8.3331 11.692M11.6664 10.8337V11.6837C11.6664 12.592 11.6581 13.3337 9.99977 13.3337C8.34977 13.3337 8.3331 12.6003 8.3331 11.692V10.8337C8.3331 10.0003 8.3331 10.0003 9.16644 10.0003H10.8331C11.6664 10.0003 11.6664 10.0003 11.6664 10.8337Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBriefcase, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/briefcase.39b7fb13.svg";
export { ForwardRef as ReactComponent };